import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Typography } from '@material-ui/core';

function DingDong({ right, title: titleText }) {
  const alignDong = right
    ? 'left'
    : 'right';

  const title = (
    <div style={{ display: 'inline-block', verticalAlign: 'top', margin: '0 10px 0 10px' }}>
      <Typography variant="body1">
        {titleText}
      </Typography>
    </div>
  );

  const dot = (
    <div
      style={{
        height: 27,
        width: 27,
        backgroundColor: '#AC893A',
        border: 1,
        borderColor: 'black',
        borderStyle: 'solid',
        borderRadius: '50%',
        display: 'inline-block',
      }}
    />
  );

  const line = (width) => (
    <span
      style={{
        verticalAlign: 'super',
      }}
    >
      <div
        style={{
          display: 'inline-block',
          backgroundColor: null,
          borderTop: '1px solid black',
          width,
          paddingBottom: '8px',
        }}
      />
    </span>
  );

  const longDong = right
    ? (
      <>
        {line('25%')}
        {dot}
        {' '}
        {title}
      </>
    )
    : (
      <>
        {title}
        {dot}
        {line('33%')}
      </>
    );

  return (
    <Grid
      item
      xs
      style={{
        padding: '27px 0 25px 0',
        textAlign: alignDong,
        alignItems: 'center',
        verticalAlign: 'middle',
      }}
    >
      {longDong}
    </Grid>
  );
}

DingDong.propTypes = {
  right: PropTypes.bool,
  title: PropTypes.string,
};

DingDong.defaultProps = {
  right: false,
  title: undefined,
};

export default DingDong;
